import { sha256 } from 'js-sha256'

import { Tournament } from '../schemas/Tournament'

export const withHashedPin = (tournament: Tournament, pin: number): Tournament => ({
  ...tournament,
  hashedPin: sha256(pin.toString()),
})

export const checkPin = (tournament: Tournament) => (providedPin: number) =>
  sha256(providedPin.toString()) === tournament.hashedPin



// WEBPACK FOOTER //
// ./src/helpers/tournament.ts